const whitelisted = `_.#&!+-`;
export const regexps = {
  email: {
    value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,// eslint-disable-line no-useless-escape,max-len
    message: 'The email format is invalid',
  },
  specialChars: {
    value: /^(?!\s)[A-Za-zÀ-ȕ0-9\s-]*(?!\s)$/,
    message: 'must not contain special characters',
  },
  whitelisted: {
    value: `^[A-Za-zÀ-ȕ0-9\\s${whitelisted}]+$`,
    message: `must only include ${whitelisted}, letters and numbers`,
  },
  noSpace: {
    value: /^[^\s].*[^\s]$/,
    message: 'must not start or end with a space',
  },
  consecutiveSpecialChars: {
    value: `^((?!([\\s${whitelisted}][\\s${whitelisted}])).)*$`,
    message: `must not include multiple consecutive ${whitelisted} characters or spaces`,
  },
  percentage: {
    value: /^100$|^\d{0,2}(\.\d{1,5})? *%?$/,
    message: 'must be a valid percentage',
  },
  url: {
    value: /^https?:\/\/[a-z0-9.-/]*$/,
    message: 'must be a valid url',
  },
  Numbers: {
    value: /^[0-9]{1,}$/,
    message: 'must be a valid number',
  },
  domain: {
    value: /^[a-z0-9](?:[a-z0-9-.]{0,61}[a-z0-9])?(?:\\.[a-z0-9](?:[.-0-9a-z]{0,61}[0-9a-z])?)*$/,
    message: 'must be a valid domain',
  },
  phoneNumbers:{
    value: /^(?=.*[0-9])[- + 0-9]+$/,
    message: 'must be a valid number',
  },
};